import styled from "styled-components";

export const HeaderImage = styled.div`
  background-color: ${(props) => props.theme.colors.primary_color};
  border-radius: 100%;
  height: 105px;
  position: absolute;
  right: -25px;
  top: -25px;
  width: 105px;
`;
